export default function getSelectStyles(isInvalid) {
  return {
    control: (provided, state) => isInvalid ? ({
      ...provided,
      borderColor: 'var(--bs-form-invalid-color) !important',
      boxShadow: state.isFocused ? '0 0 0 1px var(--bs-form-invalid-color)' : ''
    }) : provided
  }
};
